import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { IntakesProvider } from "@/intakes/IntakesContext";

export function AppShell() {
  return (
    <IntakesProvider>
      <div className="flex min-h-screen bg-background text-foreground">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="mx-auto w-full max-w-[1400px] flex-1 px-6 py-8 md:px-8 md:py-10">
            <Outlet />
          </main>
        </div>
      </div>
    </IntakesProvider>
  );
}
